/* eslint-disable @typescript-eslint/naming-convention */
export class TmhData {
  _id: {
    $oid: string
  };
  model: string;
  manufacturer: string;
  generalNote_de: string;
  constructionYearNote_de: string;
  Compatibility: EcarCompatibility;
  timestamp: string; // YYYY-MM-DDT00:00:00.000Z
  type: string; // always "tmhData"
  _etag: {
    $oid: string;
  };
}

export enum EcarCompatibility {
  TRUE = 'true',
  FALSE = 'false',
  WALLBOX = 'Wallbox'
}
